import React from 'react';
import { Provider } from 'react-redux';
import { Route, BrowserRouter, Routes } from 'react-router-dom';

import 'antd/dist/reset.css';

import { store } from './store';
import ToastProvider from './components/toast/ToastProvider';
import './App.css';

import {
  Auth,
  SearchShops,
  ExistingShopSettings,
  Home,
  NewShop,
  FitQuiz,
  Widget,
  WidgetTranslations,
  Coupons,
  ShopBilling,
  AdvancedSettings,
  AvailableFeatures,
  OnboardingSteps,
  SizeMapping,
  SizeConversion,
  ShopHistory,
  Shopify,
  ShopifyGraphql,
  AuditLog,
} from './pages';

function App() {
  return (
    <Provider store={store}>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='login' element={<Auth />} />
            <Route path='newshop' element={<NewShop />} />
            <Route path='coupon' element={<Coupons />} />
            <Route path='existingshop/:id' element={<ExistingShopSettings />}>
              <Route path='fitquiz' element={<FitQuiz />} />
              <Route path='onboarding-steps' element={<OnboardingSteps />} />
              <Route path='widget' element={<Widget />} />
              <Route path='size-mapping' element={<SizeMapping />} />
              <Route path='size-conversion' element={<SizeConversion />} />
              <Route path='translations' element={<WidgetTranslations />} />
              <Route path='billing' element={<ShopBilling />} />
              <Route path='available-features' element={<AvailableFeatures />} />
              <Route path='advanced-settings' element={<AdvancedSettings />} />
              <Route path='shopify' element={<Shopify />} />
              <Route path='shopify-graphql' element={<ShopifyGraphql />} />
              <Route path='history' element={<ShopHistory />} />
            </Route>
            <Route path='searchshops' element={<SearchShops />} />
            <Route path='audit' element={<AuditLog />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </Provider>
  );
}

export default App;
